import React from 'react';
import styled from 'styled-components';

interface InlineBarProps {
  /** Percentage value (0–100) */
  percent: number;
  /** Whether to show the percentage text (default true) */
  showPercent?: boolean;
  /** Custom bar color (default var(--ink)) */
  color?: string;
  /** Track width in px (default 80) */
  trackWidth?: number;
  className?: string;
}

export const InlineBar: React.FC<InlineBarProps> = ({
  percent,
  showPercent = true,
  color,
  trackWidth = 80,
  className
}) => (
  <Wrapper className={className}>
    <Track $width={trackWidth}>
      <Fill $percent={Math.min(Math.max(percent, 0), 100)} $color={color} />
    </Track>
    {showPercent && <Pct>{percent.toFixed(1)}%</Pct>}
  </Wrapper>
);

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Track = styled.div<{ $width: number }>`
  height: 6px;
  width: ${({ $width }) => $width}px;
  background: var(--line);
  border-radius: 3px;
  position: relative;
  overflow: hidden;
`;

const Fill = styled.div<{ $percent: number; $color?: string }>`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: ${({ $percent }) => $percent}%;
  background: ${({ $color }) => $color ?? 'var(--ink)'};
  border-radius: 3px;
  transition: width 0.3s;
`;

const Pct = styled.span`
  font-size: 12px;
  color: var(--ink-muted);
  min-width: 40px;
  font-variant-numeric: tabular-nums;
`;
